var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttentionOfferIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.25014 7.6712V2.7448C7.25014 2.33346 6.91669 2 6.50531 2C6.094 2 5.76054 2.33346 5.76054 2.7448V11.6095L3.08461 8.9459C2.8313 8.69375 2.40278 8.78225 2.27004 9.11413C2.21091 9.26195 2.22594 9.42913 2.31049 9.56398L5.09069 14H13.2501V9.1712L7.25014 7.6712ZM14.7501 8V15.5H4.26054L1.03949 10.3605C0.70054 9.8198 0.640285 9.1496 0.877322 8.55702C1.20392 7.74057 1.97716 7.29155 2.76054 7.30025C3.25355 7.30565 3.75059 7.4924 4.14282 7.88285L4.26054 8V2.7448C4.26054 1.50503 5.26557 0.5 6.50531 0.5C7.74506 0.5 8.75014 1.50503 8.75014 2.7448V6.5L14.7501 8Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttentionOfferIcon);
export default __webpack_public_path__ + "static/media/attentionOfferIcon.e29f1bf504f3253330c4e4bbe8327cfc.svg";
export { ForwardRef as ReactComponent };